/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const SmileIcon = /*#__PURE__*/ createSvgIcon(
  'SmileIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <g clipPath={`url(#${id}_0)`} fill="currentColor">
            <path d="M12.76 8.46c.685 0 1.24-.55 1.24-1.23C14 6.55 13.445 6 12.76 6c-.685 0-1.24.55-1.24 1.23 0 .68.555 1.23 1.24 1.23zM7.23 8.46a1.23 1.23 0 100-2.46 1.23 1.23 0 000 2.46z" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10 1.5a8.5 8.5 0 100 17 8.5 8.5 0 000-17zM.5 10a9.5 9.5 0 1119 0 9.5 9.5 0 01-19 0z"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.468 11.5h11.064l-.033.531C15.339 14.592 12.871 16.5 10 16.5c-2.87 0-5.338-1.908-5.499-4.469l-.033-.531zm1.112 1c.402 1.662 2.166 3 4.42 3s4.018-1.338 4.42-3H5.58z"
            />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h20v20H0z" />
            </clipPath>
          </defs>
        </>
      ),
    },
  },
  false
);

export default SmileIcon;
